export enum HeaderPanel {
  ProfilePanel = 'ProfilePanel',
  SettingsPanel = 'SettingsPanel',
  HelpPanel = 'HelpPanel',
  NotificationPanel = 'NotificationPanel',
  FeedbackPanel = 'FeedbackPanel',
}
